<div class="sopo-popup-inner-container">
    <div class="sopo-popup-title">
        Editing Tournament
    </div>
    <div class="wrapper">
        <div class="form" *ngIf="tournamentType === 'MTT'">
            <ion-item lines="none">
                <ion-input label="Table Name" mode="md" type="text" required pattern=".*\S+.*"
                    [(ngModel)]="mttTournament.mttSettings.name" maxlength="18">
                    <ion-icon class="pencil-icon" slot="end" ios="create" md="pencil"></ion-icon>
                </ion-input>
            </ion-item>

            <ion-item lines="none">
                <ion-label class="label">Game Type</ion-label>
                <app-sopo-select-button title="Game Type" [(selected)]="mttTournament.mttRules.gameMode.gameType"
                    [list]="gameTypes" [redBackground]="true">
                </app-sopo-select-button>
            </ion-item>

            <ion-item lines="none">
                <ion-label class="label">Limit Type</ion-label>
                <app-sopo-select-button title="Limit Type" [(selected)]="mttTournament.mttRules.gameMode.limitType"
                    [list]="limitTypes" [redBackground]="true">
                </app-sopo-select-button>
            </ion-item>

            <ion-item lines="none">
                <ion-label class="label">No. of seats</ion-label>
                <app-sopo-select-button title="No. of seats" [(selected)]="mttTournament.mttRules.seats"
                    [list]="seatOptions" [redBackground]="true">
                </app-sopo-select-button>
            </ion-item>

            <ion-item lines="none" *ngIf="!isQuickplay">
                <ion-label class="label">Prize</ion-label>
                <app-sopo-select-button title="Prize" [(selected)]="mttTournament.mttRules.prizeType"
                    [list]="prizeTypes['MTT']" (selectedChange)="onTypeChange($event)" [redBackground]="true">
                </app-sopo-select-button>
            </ion-item>

            <ion-item [hidden]="!isTop2 && !isTop3" lines="none">
                <div class="range-wrapper">
                    <div class="label">Winner Prize</div>
                    <div class="slide-in-range">
                        <ion-range [(ngModel)]="winnerPrize" min="1" max="100" step="1" pin="true">
                        </ion-range>
                        <ion-badge>{{winnerPrize + '%'}}</ion-badge>
                    </div>
                </div>
            </ion-item>

            <ion-item [hidden]="!isTop2 && !isTop3" lines="none">
                <div class="range-wrapper">
                    <div class="label">Second Prize</div>
                    <div class="slide-in-range">
                        <ion-range [(ngModel)]="secondPrize" min="1" max="100" step="1" pin="true">
                        </ion-range>
                        <ion-badge>{{secondPrize + '%'}}</ion-badge>
                    </div>
                </div>
            </ion-item>

            <ion-item [hidden]="!isTop3" lines="none">
                <div class="range-wrapper">
                    <div class="label">Third Prize</div>
                    <div class="slide-in-range">
                        <ion-range [(ngModel)]="thirdPrize" min="1" max="100" step="1" pin="true">
                        </ion-range>
                        <ion-badge>{{thirdPrize + '%'}}</ion-badge>
                    </div>
                </div>
            </ion-item>

            <ion-item lines="none" *ngIf="isFreeRoll">
                <ion-label class="label">Winning Amount</ion-label>
                <app-sopo-select-button title="Winning Amount" [(selected)]="mttTournament.mttRules.winningAmount"
                    [selectedText]="mttTournament.mttRules.winningAmount + ' chips'" [list]="winningAmounts" listText="chips"
                    [redBackground]="true">
                </app-sopo-select-button>
            </ion-item>

            <ion-item lines="none">
                <ion-label class="label">Max. Players</ion-label>
                <app-sopo-select-button title="Max. Players" [(selected)]="mttTournament.mttRules.maxHumanPlayers"
                    [selectedText]="mttTournament.mttRules.maxHumanPlayers + ' players'" [list]="maxHumanOptions"
                    (selectedChange)="restrictionMaxHumen($event)" listText="players" [redBackground]="true">
                </app-sopo-select-button>
            </ion-item>

            <ion-item lines="none">
                <ion-label class="label">Break Period</ion-label>
                <app-sopo-select-button title="Break Period" [(selected)]="mttTournament.mttSettings.breakPeriod"
                    [listObject]="breakPeriodOptions" [redBackground]="true">
                </app-sopo-select-button>
            </ion-item>

            <ion-item lines="none">
                <ion-label class="label">Break Length</ion-label>
                <app-sopo-select-button title="Break Length" [(selected)]="mttTournament.mttSettings.breakLength"
                    [selectedText]="mttTournament.mttSettings.breakLength + ' minutes'" [list]="breakLengthOptions"
                    listText="minutes" [redBackground]="true" [disabled]="mttTournament.mttSettings.breakPeriod == 0">
                </app-sopo-select-button>
            </ion-item>

            <ion-item lines="none">
                <ion-label class="label">Late Registration</ion-label>
                <app-sopo-select-button title="Late Registration" [(selected)]="lateRegPeriodInMinutes"
                    [selectedText]="lateRegPeriodInMinutes + ' minutes'" [list]="lateRegisterOptions" listText="minutes"
                    [disabled]="restriction" (selectedChange)="checkRebuy($event)" [redBackground]="true">
                </app-sopo-select-button>
            </ion-item>

            <ion-item lines="none">
                <ion-label class="label">Starting Chips</ion-label>
                <app-sopo-select-button title="Starting Chips" [(selected)]="mttTournament.mttRules.startingChips"
                    [selectedText]="mttTournament.mttRules.startingChips + ' chips'" [list]="startingChipsOptions"
                    listText="chips" [redBackground]="true">
                </app-sopo-select-button>
            </ion-item>

            <ion-item lines="none">
                <ion-label class="label">Start Date and Time</ion-label>
                <ion-datetime-button datetime="datetime-edit-tournament"
                    *ngIf="selectedTimeIsoString"></ion-datetime-button>
                <ion-modal [keepContentsMounted]="true">
                    <ng-template>
                        <ion-datetime [showDefaultButtons]="true" *ngIf="selectedTimeIsoString" color="date-picker"
                            id="datetime-edit-tournament" [(ngModel)]="selectedTimeIsoString" [min]="minTimeIsoString"
                            [max]="maxTimeIsoString" (ionChange)="onDateChange()"></ion-datetime>
                    </ng-template>
                </ion-modal>
            </ion-item>

            <ion-item lines="none">
                <ion-label class="label">Blinds Timer</ion-label>
                <app-sopo-select-button title="Blinds Timer" [(selected)]="mttTournament.mttRules.blindsTime"
                    [selectedText]="mttTournament.mttRules.blindsTime + ' minutes'" [list]="blindsTimerOptions"
                    listText="minutes" [redBackground]="true">
                </app-sopo-select-button>
            </ion-item>

            <ion-item lines="none" *ngIf="!isQuickplay">
                <ion-label class="label">Blind Structure</ion-label>
                <app-sopo-select-button title="Blinds Structure" 
                    [selected]="selectedMttBlindsStructureType()"
                    [list]="mttBlindStructureType"
                    [isInClub]="true" 
                    (selectedChange)="onBlindStructureChange($event)">
                </app-sopo-select-button>
            </ion-item>

            <ion-item lines="none" [hidden]="!isStaging">
                <ion-label class="label">Introduce Bots</ion-label>
                <app-sopo-select-button title="Introduce Bots" [(selected)]="allowBots"
                    [listObject]="[{value: true, text: 'Yes'}, {value: false, text: 'No'}]"
                    [hidden]="validBotOptions.length <= 0" [redBackground]="true">
                </app-sopo-select-button>
                <div [hidden]="validBotOptions.length > 0" class="no-bots">No bots.</div>
            </ion-item>

            <ion-item lines="none" [hidden]="!allowBots">
                <ion-label class="label">No. of Bots</ion-label>
                <app-sopo-select-button title="No. of Bots" [(selected)]="bots" [list]="validBotOptions" [redBackground]="true">
                </app-sopo-select-button>
            </ion-item>

            <ion-item lines="none" *ngIf="!isQuickplay">
                <ion-label class="label">Timebank per Hand</ion-label>
                <app-sopo-select-button title="Timebank per Hand" [(selected)]="mttTournament.mttRules.timebankPerHand"
                    [listObject]="timebankPerHandOptions" [redBackground]="true">
                </app-sopo-select-button>
            </ion-item>

            <ng-container *ngIf="!isFreeRoll">
                <ion-item lines="none">
                    <ion-label class="label">Rebuy Limit</ion-label>
                    <app-sopo-select-button title="Rebuy Limit" [(selected)]="mttTournament.mttRules.rebuyLimit"
                        [listObject]="rebuyLimitOptions" (selectedChange)="checkLateReg($event)" [redBackground]="true">
                    </app-sopo-select-button>
                </ion-item>

                <ion-item lines="none">
                    <ion-label class="label">Rebuy Price (Buy-In x)</ion-label>
                    <app-sopo-select-button title="Rebuy Price (Buy-In x)" [(selected)]="rebuyPriceMultiplier"
                        [selectedText]="rebuyPriceMultiplier + ' chips'" [list]="rebuyPriceMultiplierOptions"
                        listText="chips" [disabled]="mttTournament.mttRules.rebuyLimit == 0" [redBackground]="true">
                    </app-sopo-select-button>
                </ion-item>

                <ion-item lines="none">
                    <ion-label class="label">Addon Period</ion-label>
                    <app-sopo-select-button title="Addon Period" [(selected)]="mttTournament.mttRules.addonPeriod"
                        [listObject]="addonPeriodOptions" [redBackground]="true">
                    </app-sopo-select-button>
                </ion-item>

                <ion-item lines="none">
                    <ion-label class="label">Addon Price (Buy-In x)</ion-label>
                    <app-sopo-select-button title="Addon Price (Buy-In x)" [(selected)]="addonPriceMultiplier"
                        [list]="addonPriceMultiplierOptions" listText="chips"
                        [selectedText]="addonPriceMultiplier + ' chips'"
                        [disabled]="mttTournament.mttRules.addonPeriod == 0"
                        [redBackground]="true">
                    </app-sopo-select-button>
                </ion-item>
            </ng-container>

            <ion-item lines="none" *ngIf="!isQuickplay">
                <ion-toggle [(ngModel)]="mainStage" disabled="true" justify="space-between">
                    <div class="label">Main Stage</div>
                </ion-toggle>
            </ion-item>

            <ion-item lines="none">
                <ion-toggle [(ngModel)]="mttTournament.mttSettings.forceFeltAndBackground" [disabled]="mainStage" justify="space-between">
                    <div class="label">Forced Felt And Background</div>
                </ion-toggle>
            </ion-item>

            <app-felt-and-background-selector
                *ngIf="mttTournament.mttSettings.forceFeltAndBackground && !activeCommunityFeltMenu && !mainStage"
                [felts]="felts"
                [backgrounds]="backgrounds"
                (felt)="setFelt($event)"
                (background)="setBackground($event)"
                [selectedFelt]="selectedFelt"
                [selectedBackground]="selectedBackground"
                (openCommunityFeltMenu)="activateCommunityFeltsMenu()"
                [@slideLeft]>
            </app-felt-and-background-selector>

            <app-community-felts 
                *ngIf="mttTournament.mttSettings.forceFeltAndBackground && activeCommunityFeltMenu && !mainStage"
                (closeCommunityFeltSelectorEmitter)="deActivateCommunityFeltsMenu($event)"
                (setForcedFeltEmitter)="setFelt($event)"
                [selectedForcedFelt]="selectedFelt"
                [openedFromTableSettings]="true"
                [@slideRight]>
            </app-community-felts>

            <ion-item lines="none" *ngIf="false">
                <ion-toggle
                    [(ngModel)]="mttTournament.mttSettings.collectWalletAddress"
                    justify="space-between"
                >
                    <div class="label">Collect Wallet Address, Twitter and Email</div>
                </ion-toggle>
            </ion-item>

            <ion-item lines="none" *ngIf="!isQuickplay">
                <ion-toggle [(ngModel)]="mttTournament.mttSettings.restricted" [disabled]="mainStage" justify="space-between">
                    <div class="inner">
                        <div class="label">Restricted</div>
                        <div class="info">Joining requires manager approval</div>
                    </div>
                </ion-toggle>
            </ion-item>

            <ion-item lines="none" class="add-multi-day-holder" *ngIf="!isQuickplay">
                <ion-label class="label">Multi Day Settings</ion-label>
                <div slot="end"
                    [ngClass]="startTimeIsoString === '' ? 'sopo-popup-grey-button': 'sopo-popup-green-button clickable'"
                    (click)="showMultiDaySettingsInput()">ADD</div>
            </ion-item>
            <ion-item *ngFor="let level of multiDayTournamentSettings.levelsArray; let i=index">
                <ion-label class="label">{{level.blindLevelToStopAt}} -
                    {{ level.resumeDate | sopoDate:sopoDateOptions}}</ion-label>
                <ion-icon class="remove" name="close-outline" (click)="removeFromLevels(i)"></ion-icon>
            </ion-item>

            <ion-item lines="none" *ngIf="!isQuickplay">
                <ion-label class="label">Bounty Format</ion-label>
                <app-sopo-select-button
                    title="Bounty Format"
                    [selected]="bountyFormat"
                    (selectedChange)="onBountyFormatChange($event)"
                    [list]="bountyFormats"
                    [redBackground]="true">
                </app-sopo-select-button>
            </ion-item>

            <ng-container *ngIf="!isQuickplay && bountyFormat !== BountyFormatEnum.NONE">
                <ion-item lines="none">
                    <div class="range-wrapper">
                        <div class="label">Contribution Percent (1-99):</div>
                        <div class="slide-in-range">
                            <ion-range [(ngModel)]="mttTournament.mttBountySettings.contributionPercent"
                                min="1" max="99" step="1" pin="true">
                            </ion-range>
                            <ion-badge>{{mttTournament.mttBountySettings.contributionPercent}} %</ion-badge>
                        </div>
                    </div>
                </ion-item>

                <ion-item lines="none">
                    <ion-label position="stacked" class="label">
                        Sponsored Bounty Pool (required for freeroll)
                    </ion-label>
                    <ion-input
                        type="number"
                        min="0"
                        [(ngModel)]="mttTournament.mttBountySettings.sponsoredBountyPool"
                        placeholder="0">
                    </ion-input>
                </ion-item>

                <!--
                    Mystery envelope mode / list / curve preset / count are not editable
                    from the in-game edit dialog. Admins should set those at config time
                    via the CMS or the in-app create-table flow.
                -->
            </ng-container>

            <ion-item lines="none" *ngIf="!isQuickplay">
                <ion-toggle [(ngModel)]="mttTournament.mttSettings.requireKyc" justify="space-between">
                    <div class="inner">
                        <div class="label">Require KYC</div>
                        <div class="info">Joining requires KYC verification</div>
                    </div>
                </ion-toggle>
            </ion-item>
            @if (isFreeRoll) {
                <ion-item lines="none">
                    <ion-toggle [checked]="enableRemoveAfkPlayers()" (ionChange)="enableRemoveAfkPlayers.set($event.detail.checked)"
                        justify="space-between">
                        <div class="label">Remove Afk Players</div>
                    </ion-toggle>
                </ion-item>
            
                @if (enableRemoveAfkPlayers()) {
                    <ion-item lines="none">
                        <ion-label class="label">Remove Option</ion-label>
                        <app-sopo-select-button title="AFK Remove Type" [list]="selectableAfkTypes" [selected]="selectedAfkType()"
                            (selectedChange)="selectedAfkType.set($event)" [isInClub]="true"></app-sopo-select-button>
                    </ion-item>
                    <ion-item lines="none">
                        <ion-label class="label">Amount</ion-label>
            
                        <app-sopo-select-button title="AFK Amount" [list]="selectableOptions()" [selected]="selectedAfkAmount()"
                            (selectedChange)="handleAfkAmountChange($event)" [isInClub]="true"></app-sopo-select-button>
                    </ion-item>
                }
            }
        </div>


        <div class="form" *ngIf="tournamentType === 'SNG'">
            <ion-item lines="none">
                <ion-input label="Table Name" mode="md" type="text" required pattern=".*\S+.*"
                    [(ngModel)]="sngTournament.sngSettings.name" maxlength="18">
                    <ion-icon class="pencil-icon" slot="end" ios="create" md="pencil"></ion-icon>
                </ion-input>
            </ion-item>

            <ion-item lines="none">
                <ion-label class="label">Game Type</ion-label>
                <app-sopo-select-button title="Game Type" [(selected)]="sngTournament.sngRules.gameMode.gameType"
                    [list]="gameTypes" [redBackground]="true">
                </app-sopo-select-button>
            </ion-item>

            <ion-item lines="none">
                <ion-label class="label">Limit Type</ion-label>
                <app-sopo-select-button title="Limit Type" [(selected)]="sngTournament.sngRules.gameMode.limitType"
                    [list]="limitTypes" [redBackground]="true">
                </app-sopo-select-button>
            </ion-item>

            <ion-item lines="none">
                <ion-label class="label">No. of seats</ion-label>
                <app-sopo-select-button title="No. of seats" [(selected)]="sngTournament.sngRules.seats"
                    [list]="seatOptions" [redBackground]="true">
                </app-sopo-select-button>
            </ion-item>

            <ion-item lines="none" *ngIf="!isQuickplay">
                <ion-label class="label">Prize</ion-label>
                <app-sopo-select-button title="Prize" [(selected)]="sngTournament.sngRules.prizeType"
                    [list]="prizeTypes['SNG']" (selectedChange)="onTypeChange($event)" [redBackground]="true">
                </app-sopo-select-button>
            </ion-item>

            <ion-item [hidden]="!isTop2 && !isTop3" lines="none">
                <div class="range-wrapper">
                    <div class="label">Winner Prize</div>
                    <div class="slide-in-range">
                        <ion-range [(ngModel)]="winnerPrize" min="1" max="100" step="1" pin="true">
                        </ion-range>
                        <ion-badge>{{winnerPrize + '%'}}</ion-badge>
                    </div>
                </div>
            </ion-item>

            <ion-item [hidden]="!isTop2 && !isTop3" lines="none">
                <div class="range-wrapper">
                    <div class="label">Second Prize</div>
                    <div class="slide-in-range">
                        <ion-range [(ngModel)]="secondPrize" min="1" max="100" step="1" pin="true">
                        </ion-range>
                        <ion-badge>{{secondPrize + '%'}}</ion-badge>
                    </div>
                </div>
            </ion-item>

            <ion-item [hidden]="!isTop3" lines="none">
                <div class="range-wrapper">
                    <div class="label">Third Prize</div>
                    <div class="slide-in-range">
                        <ion-range [(ngModel)]="thirdPrize" min="1" max="100" step="1" pin="true">
                        </ion-range>
                        <ion-badge>{{thirdPrize + '%'}}</ion-badge>
                    </div>
                </div>
            </ion-item>

            <ion-item lines="none">
                <ion-label class="label">Starting Chips</ion-label>
                <app-sopo-select-button title="Starting Chips" [(selected)]="sngTournament.sngRules.startingChips"
                    [selectedText]="sngTournament.sngRules.startingChips + ' chips'" [list]="startingChipsOptions"
                    listText="chips" [redBackground]="true">
                </app-sopo-select-button>
            </ion-item>

            <ion-item lines="none">
                <ion-label class="label">Blinds Timer</ion-label>
                <app-sopo-select-button title="Blinds Timer" [(selected)]="sngTournament.sngRules.blindsTime"
                    [selectedText]="sngTournament.sngRules.blindsTime + ' minutes'" [list]="blindsTimerOptions"
                    listText="minutes" [redBackground]="true">
                </app-sopo-select-button>
            </ion-item>

            <ion-item lines="none" *ngIf="!isQuickplay">
                <ion-label class="label">Timebank per Hand</ion-label>
                <app-sopo-select-button title="Timebank per Hand" [(selected)]="sngTournament.sngRules.timebankPerHand"
                    [listObject]="timebankPerHandOptions" [redBackground]="true">
                </app-sopo-select-button>
            </ion-item>

            <ion-item lines="none" *ngIf="!isQuickplay">
                <ion-label class="label">Blind Structure</ion-label>
                <app-sopo-select-button title="Blind Structure" [(selected)]="selectedSngBlindsStructureType"
                    [list]="sngBlindStructureType" [isInClub]="true">
                </app-sopo-select-button>
            </ion-item>

            <ion-item lines="none"  *ngIf="!isQuickplay">
                <ion-toggle [(ngModel)]="mainStage" disabled="true" justify="space-between">
                    <div class="label">Main Stage</div>
                </ion-toggle>
            </ion-item>

            <ion-item lines="none">
                <ion-toggle [(ngModel)]="sngTournament.sngSettings.forceFeltAndBackground" [disabled]="mainStage" justify="space-between">
                    <div class="label">Forced Felt And Background</div>
                </ion-toggle>
            </ion-item>

            <app-felt-and-background-selector
                *ngIf="sngTournament.sngSettings.forceFeltAndBackground && !activeCommunityFeltMenu && !mainStage"
                [felts]="felts"
                [backgrounds]="backgrounds"
                (felt)="setFelt($event)"
                (background)="setBackground($event)"
                [selectedFelt]="selectedFelt"
                [selectedBackground]="selectedBackground"
                (openCommunityFeltMenu)="activateCommunityFeltsMenu()"
                [@slideLeft]>
            </app-felt-and-background-selector>

            <app-community-felts 
                *ngIf="sngTournament.sngSettings.forceFeltAndBackground && activeCommunityFeltMenu && !mainStage"
                (closeCommunityFeltSelectorEmitter)="deActivateCommunityFeltsMenu($event)"
                (setForcedFeltEmitter)="setFelt($event)"
                [selectedForcedFelt]="selectedFelt"
                [openedFromTableSettings]="true"
                [@slideRight]>
            </app-community-felts>

            <ion-item lines="none" *ngIf="false">
                <ion-toggle
                    [(ngModel)]="sngTournament.sngSettings.collectWalletAddress"
                    justify="space-between"
                >
                    <div class="label">Collect Wallet Address, Twitter and Email</div>
                </ion-toggle>
            </ion-item>

            <ion-item lines="none" *ngIf="!isQuickplay">
                <ion-toggle [(ngModel)]="sngTournament.sngSettings.restricted" [disabled]="mainStage" justify="space-between">
                    <div class="inner">
                        <div class="label">Restricted</div>
                        <div class="info">Joining requires manager approval.</div>
                    </div>
                </ion-toggle>
            </ion-item>
        </div>
    </div>
    <div class="sopo-popup-button-container">
        <div class="sopo-popup-green-button clickable" (click)="editTournament()">
            <ion-icon name="checkmark-circle"></ion-icon>
            Save
        </div>
        <div class="sopo-popup-red-button close clickable" (click)="close()">
            <ion-icon name="close-circle"></ion-icon>
            Close
        </div>
    </div>
</div>
